import React, { useState, useEffect } from 'react'; 
import Navbar from '../components/navbar';
import { doc, getDoc } from "firebase/firestore";
import { db } from '../firebase';
import data from '../data/AboutPageContentEnglish.json';


const About = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      // const isDevelopment = process.env.NODE_ENV === 'development';

      const docRef = doc(db, "content", "content_about_page_plant_finder_english");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setContent(JSON.parse(docSnap.data().value));
      } else {
        setContent(data); // or handle fallback
      }
    };
    fetchContent();
  }, []);

  if (!content) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Navbar content={content} />
      <section className="w-full bg-pf-bgDarker relative min-h-[100vh] flex flex-col items-center justify-center">

        <div className="bg-white rounded-3xl shadow-2xl w-full max-w-5xl flex flex-col items-center justify-center px-10 py-20">
          <div className="w-full flex md:flex-row flex-col items-center justify-center md:space-x-20">
            <div className="w-full flex flex-col items-center justify-center">
              <h2 className="text-3xl font-bold mb-6 text-pf-titleDark text-center">{content.title}</h2>
              <p className="text-gray-600 text-lg text-left" dangerouslySetInnerHTML={{ __html: content.content }} />
            </div>
          </div>
        </div>
      </section>
    </>
  )
};


export default About; 